
import { Vue, Component, Prop } from 'vue-property-decorator';
import { List } from 'vant';
import { fetchNewslist } from '@/api/api';
import NewsItem from '@/components/next/NewsItem.vue';
Vue.use(List);
@Component({
  components: {
    NewsItem,
  },
})
export default class NewsList extends Vue {
  @Prop() classid!: number;
  @Prop({ default: '资讯' }) title!: string;

  loading = false;
  finished = false;
  page = 1;
  getNewsList: any[] = [];

  onLoad() {
    this.loading = true;
    fetchNewslist(this.page, this.classid).then((res) => this.endNewsData(res));
  }
  endNewsData(res: any) {
    if (!res.data) {
      this.finished = true;
    } else {
      this.getNewsList = [...this.getNewsList, ...res.data];
      this.page = this.page + 1;
    }
    this.loading = false;
  }

  onNavTo(newsItem: any) {
    if (window.udid && newsItem.dataType !== 7 && newsItem.dataType !== 5) {
      const { id, classId, dataType } = newsItem;
      const option = {
        dt: dataType,
        cid: classId,
        nid: id,
      };
      window.handleMessage(
        JSON.stringify({
          action: 'mJump',
          data: JSON.stringify(option),
        }),
      );
    } else {
      location.href = newsItem.targetUrl;
    }
  }
}
